import React from 'react';

interface SpacerProps {
  data: {
    id?: string;
    height?: string;
    [key: string]: unknown;
  };
  styles?: string;
}

export const Spacer: React.FC<SpacerProps> = ({ data, styles: _styles }) => (
  <div className="">
    <span className="text-xs text-[var(--text-secondary)]">Spacer ({data.height || 'auto'})</span>
  </div>
);
